module.exports = __webpack_public_path__ + "static/4-de5593832fff15d4d5fbe1af40da95ed.jpeg";